import React from 'react'

import { Table } from '../../../../../../../components/Table'
import { TableHead } from '../../../../../../../components/Table/TableHead'
import { TableBody } from '../../../../../../../components/Table/TableBody'

import { MatchingFile } from '../../../../core/_models'
import { DisputeRecord, DisputeReasonLookupItem } from '../../core/response.types'
import { DisputeRow } from './DisputeRow'

interface Props {
  items: DisputeRecord[]
  loading?: boolean
  canManageBills: boolean
  onFilesChange: (disputeId: number, files: MatchingFile[]) => void
  onResolveSuccess: (dispute: DisputeRecord) => void
  onReject: (dispute: DisputeRecord) => void
  onChunkReleased: (disputeId: number, heldUntil: string) => void
  reasons: DisputeReasonLookupItem[]
  onDisputeUpdated: (dispute: DisputeRecord) => void
}

const DisputesTable: React.FC<Props> = ({
  items,
  loading,
  canManageBills,
  onFilesChange,
  onResolveSuccess,
  onReject,
  onChunkReleased,
  reasons,
  onDisputeUpdated,
}) => {
  if (loading) {
    return <div className='text-muted'>Загрузка…</div>
  }
  if (!items.length) {
    return <div className='text-muted'>Записей не найдено</div>
  }

  return (
    <Table>
      <TableHead>
        <tr>
          <th className='min-w-160px'>
            ID тикета
            <br />
            <small>Токен UUID / ID тикета мерчанта</small>
          </th>
          <th>Тип</th>
          <th>Мерчант</th>
          <th>Начало диспута</th>
          <th>Сумма</th>
          <th>Причина</th>
          <th>Ситуация</th>
          <th>Статус диспута</th>
          <th>Статус тикета</th>
          <th className='min-w-120px'>Виновник</th>
          <th>Освобождение выплаты</th>
          <th>Автоотмена через</th>
          <th className='text-center'>Чек</th>
          <th>Кто открыл</th>
          <th>Кто закрыл</th>
          <th>Комментарий</th>
          <th className='w-250px text-end'>Действия</th>
        </tr>
      </TableHead>
      <TableBody>
        {items.map((d) => (
          <DisputeRow
            key={d.id}
            dispute={d}
            canManageBills={canManageBills}
            onFilesChange={onFilesChange}
            onResolveSuccess={onResolveSuccess}
            onReject={onReject}
            onChunkReleased={onChunkReleased}
            reasons={reasons}
            onDisputeUpdated={onDisputeUpdated}
          />
        ))}
      </TableBody>
    </Table>
  )
}

export default DisputesTable
